import { useSuspenseQuery } from "@apollo/client/react";

import {
  GetGeoItemDetailDocument,
  type GetGeoItemDetailQuery,
  type GetGeoItemDetailQueryVariables,
} from "~/features/geoItems/gqls";
import { useTenant } from "~/features/tenant/context";

export function useGeoItemDetail(id: string) {
  const { tenantId } = useTenant();
  if (!tenantId) {
    throw new Error("Tenant ID is required");
  }

  const { data, refetch } = useSuspenseQuery<GetGeoItemDetailQuery, GetGeoItemDetailQueryVariables>(
    GetGeoItemDetailDocument,
    { variables: { input: { tenantId, id } } },
  );

  return { geoItem: data.cnutGetGeoItem ?? null, refetch };
}
